import type { PayloadDrawerState } from "./useKai.types"

export const TOGGLE_KAI = "TOGGLE_KAI" as const

export const toggle = () => ({
  type: TOGGLE_KAI
})

export const UPDATE_DRAWER_STATE = "UPDATE_DRAWER_STATE" as const

export const updateDrawerState = (payload: PayloadDrawerState) => ({
  type: UPDATE_DRAWER_STATE,
  payload
})

export const CLOSE_DRAWER = "CLOSE_DRAWER" as const

export const closeDrawer = (payload: Pick<PayloadDrawerState, "drawerId">) => ({
  type: CLOSE_DRAWER,
  payload
})

export const SET_DIRTY_CONTEXT = "SET_DIRTY_CONTEXT" as const

export const setDirtyContext = (isDirty: boolean) => ({
  type: SET_DIRTY_CONTEXT,
  payload: isDirty
})
